import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static values = { to: String };
  static targets = ["select"];
  reset() {
    this.selectTarget.value = this.toValue;
  }
}
